import axios, {AxiosError, AxiosInstance} from "axios";

const axiosInstance = axios.create({
    withCredentials: true
});

export const axiosErrorTransformer = (error: AxiosError) => {

    const message = error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message;
    const errors = error.response && error.response.data && error.response.data.errors ? error.response.data.errors : null;

    return {
        message,
        errors,
        original: error
    }
}

export default function useAxios(): AxiosInstance {
    return axiosInstance;
}
